<template>
    <app-tooltip :value="text">
        <app-button
            :value="name"
            :name="`action-${name}`"
            :icon="icon"
            icon-size="1rem"
            icon-prefix="far"
            :disabled="disabled"
            small
            @click="onBtnClick"
        />
    </app-tooltip>
</template>

<script>
export default {
    name: 'AppWysiwygToolbarAction',
    props: {
        editor: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onBtnClick() {
            if (this.disabled) {
                return;
            }
            this.$emit('run');
        }
    }
};
</script>
